var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivityCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.67 15.2213V18.7575H0.5625V5.385L5.0475 0.5625H14.67V5.64375",
    stroke: "black",
    strokeWidth: 1.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.055 0.5625L5.0475 5.385H0.5625",
    stroke: "black",
    strokeWidth: 1.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49414 15.5352H9.24789",
    stroke: "black",
    strokeWidth: 1.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49414 13.0859H8.49789",
    stroke: "black",
    strokeWidth: 1.125
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49414 10.8008H9.99789",
    stroke: "black",
    strokeWidth: 1.125
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49414 8.51172H12.2479",
    stroke: "black",
    strokeWidth: 1.125
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5039 13.8715L10.5602 15.484C10.5609 15.5119 10.5679 15.5393 10.5808 15.5641C10.5936 15.5888 10.612 15.6103 10.6344 15.627C10.6568 15.6436 10.6827 15.6549 10.7101 15.66C10.7375 15.6651 10.7658 15.6639 10.7927 15.6565L12.3414 15.2403C12.3936 15.2294 12.4394 15.1984 12.4689 15.154L19.2452 5.98904C19.2811 5.94028 19.3071 5.88493 19.3217 5.82613C19.3362 5.76733 19.3391 5.70624 19.33 5.64634C19.321 5.58645 19.3002 5.52892 19.2689 5.47705C19.2376 5.42518 19.1964 5.37999 19.1477 5.34404L17.9702 4.46654C17.9216 4.4301 17.8663 4.4037 17.8074 4.38886C17.7485 4.37403 17.6873 4.37106 17.6272 4.38014C17.5672 4.38921 17.5096 4.41015 17.4577 4.44172C17.4059 4.47329 17.3608 4.51487 17.3252 4.56404L10.5489 13.7253C10.5191 13.7682 10.5034 13.8193 10.5039 13.8715Z",
    stroke: "black",
    strokeWidth: 1.125
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4102 5.79688L18.3114 7.24812",
    stroke: "black",
    strokeWidth: 1.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityCompleted);
export default __webpack_public_path__ + "static/media/activity-completed.1ea355a60d7aba3d0dbea6d7f49e2f75.svg";
export { ForwardRef as ReactComponent };